var radii = {
  none: '0',
  sm: '0.125rem',
  // 2px
  base: '0.625rem',
  // 10px
  md: '0.375rem',
  // 6px
  lg: '0.5rem',
  // 8px
  xl: '0.75rem',
  // 12px
  '2xl': '1rem',
  // 16px
  '3xl': '1.5rem',
  // 24px
  badge: '2.0rem',
  // 32px
  pill: '2.5rem',
  // 40px
  full: '9999px'
};
export default radii;
//# sourceMappingURL=radius.js.map